import negativeStockReportApi from "../../api/inventory/negativeStockReportApi";

export interface NegativeStockReportFilters {
    branchId?: number;
    categoryId?: number;
    groupId?: number;
}

const NegativeStockReportService = {

    /**
     * 📉 Buscar productos con stock negativo
     * POST /api/inventory/reports/negative-stock/search
     */
    search: async (
        filters: NegativeStockReportFilters,
        page = 0,
        size = 10
    ) => {

        const response = await negativeStockReportApi.addCustom(
            `/search?page=${page}&size=${size}`,
            filters
        );

        return response.data;

    },

};

export default NegativeStockReportService;
